import { createSlice } from '@reduxjs/toolkit';
import { CPAPFilterType } from 'components/SearchCpapPage';
import { t_cpap_instructions } from 'types';
import { getCpapInstructItems } from './thunk';

interface InitialState {
  loading: boolean;
  items: t_cpap_instructions[];
  totalItems: number;
  itemSearch: t_cpap_instructions[];
  currentPage: number;
  searchValue: CPAPFilterType;
}

const initialState: InitialState = {
  loading: false,
  items: [],
  totalItems: 0,
  searchValue: {
    facility_name_for_search: '',
    patient_name: '',
    patient_id: '',
    phone_number: '',
    cpap_setting_for_search: '',
    machine_no: '',
    installation_date: [null, null],
    cpap_remark: '',
    other: '',
    suspension_flg: false,
    health_authorities: '',
    health_authorities_iids: [],
  },
  currentPage: 1,
  itemSearch: [],
};

const cpapInstructionsSlices = createSlice({
  name: 'cpapInstructions',
  initialState,
  reducers: {
    setSearchValue(state, action) {
      state.searchValue = action.payload;
    },
    setCurrentPage(state, action) {
      state.currentPage = action.payload;
    },
    resetSearchValue(state) {
      state.searchValue = {
        facility_name_for_search: '',
        patient_name: '',
        patient_id: '',
        phone_number: '',
        cpap_setting_for_search: '',
        machine_no: '',
        installation_date: [null, null],
        cpap_remark: '',
        other: '',
        suspension_flg: false,
        health_authorities: '',
        health_authorities_iids: [],
      };
      state.currentPage = 1;
    },
    setItems(state, action) {
      state.items = action.payload;
    },
    setTotalItems(state, action) {
      state.totalItems = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCpapInstructItems.pending, (state) => {
      return { ...state, loading: true };
    });
    builder.addCase(getCpapInstructItems.fulfilled, (state, action) => {
      return { ...state, ...action.payload, loading: false };
    });
    builder.addCase(getCpapInstructItems.rejected, (state) => {
      return { ...state, loading: false };
    });
  },
});
export const { setSearchValue, setCurrentPage, resetSearchValue, setItems, setTotalItems } =
  cpapInstructionsSlices.actions;
export default cpapInstructionsSlices.reducer;
